class AnnouncementBarRotator extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
    if (this.items.length <= 1) return;

    this.interval = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.currentIndex = 0;
    this.timer = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    this.onMotionChange = () => {
      if (this.reducedMotion.matches) {
        this.pause();
      } else {
        this.play();
      }
    };

    this.onVisibilityChange = () => {
      if (document.hidden) {
        this.pause();
      } else {
        this.play();
      }
    };

    this.reducedMotion.addEventListener('change', this.onMotionChange);
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    if (this.canHover) {
      this.onMouseEnter = () => this.pause();
      this.onMouseLeave = () => this.play();
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }

    this.updateAccessibility();
    this.play();
  }

  disconnectedCallback() {
    this.pause();
    this.reducedMotion.removeEventListener('change', this.onMotionChange);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);

    if (this.canHover) {
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
    }
  }

  play() {
    if (this.items.length <= 1 || this.reducedMotion.matches || document.hidden) return;
    this.pause();
    this.timer = setInterval(() => this.next(), this.interval);
  }

  pause() {
    clearInterval(this.timer);
    this.timer = null;
  }

  updateAccessibility() {
    this.items.forEach((item, index) => {
      const isActive = index === this.currentIndex;
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      item.toggleAttribute('inert', !isActive);
    });
  }

  next() {
    this.items[this.currentIndex].classList.remove('is-active');
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    this.items[this.currentIndex].classList.add('is-active');
    this.updateAccessibility();
  }
}

customElements.define('announcement-bar-rotator', AnnouncementBarRotator);
